import React from 'react';


const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#333',
        textAlign: 'center',
    },
    title: {
        fontSize: '6rem',
        fontWeight: 'bold',
        color: '#ff4081',
        textShadow: '2px 2px 10px rgba(0,0,0,0.2)',
    },
    message: {
        fontSize: '1.5rem',
        marginTop: '10px',
        color: '#555',
    },
    button: {
        marginTop: '20px',
        padding: '12px 24px',
        fontSize: '1.2rem',
        color: '#fff',
        background: '#ff4081',
        textDecoration: 'none',
        borderRadius: '30px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        transition: '0.3s',
    },
};


const NotFound = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>404</h1>
            <p style={styles.message}>There is nothing here</p>
            <a href="/" style={styles.button} onClick={() => window.close()}>Go back</a>
        </div>
    );
};

export default NotFound;
